const BITIBA_REALM = 'bitiba';
const ZOOPLUS_REALM = 'zooplus';
const localesBitiba = [
    'cs-CZ',
    'da-DK',
    'de-CH',
    'de-DE',
    'en-GB',
    'es-ES',
    'fi-FI',
    'fr-BE',
    'fr-FR',
    'it-IT',
    'nl-NL',
    'pl-PL',
    'sv-SE',
];
const localesZooplus = [
    'bg-BG',
    'cs-CZ',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'el-GR',
    'en',
    'en-GB',
    'en-IE',
    'es-ES',
    'fi-FI',
    'fr-BE',
    'fr-CH',
    'fr-FR',
    'hr-HR',
    'hu-HU',
    'it-IT',
    'nb-NO',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sl-SI',
    'sv-SE',
];
const BITIBA_LOCALES = localesBitiba.map((locale) => {
    return { locale, realm: BITIBA_REALM };
});
const ZOOPLUS_LOCALES = localesZooplus.map((locale) => {
    return { locale, realm: ZOOPLUS_REALM };
});
const LOCALES = [...BITIBA_LOCALES, ...ZOOPLUS_LOCALES];

export { BITIBA_LOCALES, BITIBA_REALM, LOCALES, ZOOPLUS_LOCALES, ZOOPLUS_REALM };
//# sourceMappingURL=locales.js.map
